import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import XLSX from 'xlsx';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  Box,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { toast } from 'react-toastify';

import serverURI from 'config/URI';

import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  // gridList: {
  //   width: 500,
  //   height: 450,
  // },
  // icon: {
  //   color: 'rgba(255, 255, 255, 0.54)',
  // },
}));

const form_data_device = [
  { 
    '모델명' : 'L710A', 
    '시리얼 NO' : 'N-0001', 
    'MAC Address' : '11223344', 
    'IMEI NO' : '123456',
    '디바이스현황' : '정상',
    '디바이스상태' : '장착',
    '차량번호' : '01가0001',
    '미터기 타입' : '0->기본,104->경기_안양_KM200,105->상주_경기수원_S700',
    '상태변경사유' : '모델 장착',
  }, 
  { 
    '모델명' : 'L710A', 
    '시리얼 NO' : 'N-0001', 
    'MAC Address' : '11223355', 
    'IMEI NO' : '123457',
    '디바이스현황' : '고장',
    '디바이스상태' : '미장착',
    '차량번호' : '01가0005',
    '미터기 타입' : '0->기본,104->경기_안양_KM200,105->상주_경기수원_S700',
    '상태변경사유' : '고장 수리 전달',
  }, 
];

const form_data_modem = [
  { 
    '모델명' : 'CNR-M100', 
    '시리얼 NO' : '000001', 
    '통신회사' : 'LGU+', 
    'IMEI NO' : '000000000000001',
    'SIM NO' : '00000001',
    '개통번호' : '010-100-0100',
    '모뎀현황' : '정상',
    '모뎀상태' : '미장착',
    '디바이스 시리얼' : '',
    '상태변경사유' : '개통',
  }, 
  { 
    '모델명' : 'CNR-M100', 
    '시리얼 NO' : '000002', 
    '통신회사' : 'LGU+', 
    'IMEI NO' : '000000000000002',
    'SIM NO' : '00000002',
    '개통번호' : '010-200-0200',
    '모뎀현황' : '정상',
    '모뎀상태' : '장착',
    '디바이스 시리얼' : '12345678',
    '상태변경사유' : '개통 및 장착',
  }, 
];


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UploadDeviceFile = props => {

  const {
    type,
    openDialog,
    onClickCloseDialog,
    //onClickSaveDialog,

    // onClickUploadFile,
    // onClickDownloadFile,
    user_name,
  } = props;

  const classes = useStyles();

  const [xlsFile, setXlsFile] = useState(null);

  const [openProgress, setOpenProgress] = useState(false);

  const handleClose = () => {
    setXlsFile(null);
    onClickCloseDialog();
  }

  const uploadDeviceFile = (file) => {
    const fileData = new FormData();
    fileData.append('reg_user', user_name);
    fileData.append('xlsFile', file);
    if (type === 'manage')
      return axios.post(`${serverURI}/api/device/upload`, fileData);
    else
      return axios.post(`${serverURI}/api/modem/upload`, fileData);
  }

  const handleUploadDeviceFile = async (file) => {
    const res = await uploadDeviceFile(file);
    const result_datas = type === 'manage' ? res.data.devices : res.data.modems;
    setOpenProgress(false);

    if (result_datas.length === 0) {
      toast('업로드 사항이 존재하지 않습니다.');
      return ;
    }

    let result = true;
    let errors = [];
    result_datas.map(ret_data => {
      if (ret_data.result === 'fail') {
        result |= false;
        if (type === 'manage')
          errors.push(ret_data.name);
        else
          errors.push(`${ret_data.name}(${ret_data.serial_no})`);
      }
    });
    if (result === true) {
      toast('업로드에 성공하였습니다.');
    }
    else {
      let errorNames = '';
      errors.map((errorName, index) => {
        errorNames += errorName;
        if (index < errors.length-1) {
          errorNames += ',';
        }
      });
      toast(errorNames+' 항목을 업로드에 실패하였습니다.');
    }
  }

  const handleDownloadDeviceFileForm = e => {

    var wscols_device = [
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:40},
    ];

    var wscols_modem = [
      {wch:20},
      {wch:20},
      {wch:16},
      {wch:20},
      {wch:20},
      {wch:20},
      {wch:16},
      {wch:16},
      {wch:20},
      {wch:40},
    ];


    var wscols = type === 'manage' ? wscols_device: wscols_modem;
    var data = type === 'manage' ? form_data_device: form_data_modem;
    var sheet_name = type === 'manage' ? '디바이스정보' : '모뎀정보';
    var file_name = type === 'manage' ? 'device_excel' : 'modem_excel';
  
    const new_workbook = XLSX.utils.book_new(); // excel 파일에 해당 
    const worksheet = XLSX.utils.json_to_sheet(data); // excel sheet하단의 worksheet에 해당 
    worksheet['!cols'] = wscols;

    XLSX.utils.book_append_sheet(new_workbook, worksheet, sheet_name); // excelsheet를 excel파일에 넣음 
    //worksheet.getCell('A1').alignment = {vertical:'middle', horizontal:'center'};
    XLSX.writeFile(new_workbook, file_name + '.xlsx');
  }

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              업로드
            </Typography>
          </Toolbar>
        </AppBar>

        <List>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              엑셀파일
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-basic2" 
              //variant="outlined" 
              //value={videoFile.name}
              value={IsNoU(xlsFile) ? '' : xlsFile.name}
              margin="dense"
              disabled={true}/>
            <Box p={2} />
            <Button
              className={classes.registerListItemUpload}
              variant="contained"
              component="label"
            >
              파일선택
              <input
                type="file"
                accept=".xlsx"
                style={{ display: "none" }}
                onChange={e => {
                  const file = e.target.files[0];
                  if (file !== null && file !== undefined) {
                    setXlsFile(file);
                  }
                  //console.log(file);
                }}
              />
            </Button>
          </ListItem>
          <Divider />
          <ListItem>
          <div className={classes.row}>
            <Button
              color="primary"
              variant="contained"
              onClick={ () => {

                if (IsNoU(xlsFile)) {
                  //console.log('upload file none');
                  toast('업로드할 파일을 선택하세요.');
                  return ;
                }

                setOpenProgress(true);
                handleUploadDeviceFile(xlsFile);
               } }
            >
              업로드
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={ onClickCloseDialog }
            >
              취소
            </Button>

            {/* <a
              href={`${serverURI}/CMS/excel/COMPANY_EXCEL.xls`}
              download
            >
              업로드 양식 다운로드
            </a> */}

            <Button
              color="primary"
              variant="contained"
              component="label"
              onClick={ handleDownloadDeviceFileForm }
            >
              업로드 양식 다운로드
              {/* <a
                style={{ color: "white" }}
                //href={`${serverURI}/CMS/excel/COMPANY_EXCEL.xlsx`}
                herf={`${%PUBLIC_URL%}/COMPANY_EXCEL.xlsx`}
                download 
                >
                </a> */}
            </Button>
          </div>
          </ListItem>
        </List>

        <Backdrop className={classes.backdrop} open={openProgress} /* onClick={handleClose} */>
          <CircularProgress color="inherit" />
        </Backdrop>

      </Dialog>
    </div>
  );
}

export default UploadDeviceFile;
